module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABXUExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////////////////////////x6CpFcAAAAcdFJOUwDzVe9pNBr5Dt1QLKyS14dLIvV36dHLErydCJ82IdFfAAAAvklEQVQ4y6WS2w6DIBBERQQ0oihe0Gb//zvb1CirDk2bzuuch53ZybJfFNwkxORCys9HemvMEz4dgoSWEZAaAA0xNQBoOdACQHJAAqDiQAWAlQMrAGoTfVOjnEUECtzU4DfbD6mue/uKIm3/8V8h+0tl3XVKJ91h2ZJWDUr5cIIVtdwOVaemicSlis7TVacylKG72KzKEfjk4x2OoI6XBoMB0vc3nrUnsSnAorGh4aVOIIMGj8avZuzP6psFPAHVIC7Slovg9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-figure.png
// module id = lPMb
// module chunks = 34